const customAgentPath = "custom-agents";
const knowledgeBasePath = "knowledge-bases";
export const aiEditPath = "edit";
export const aiViewPath = "view";
export const aiClonePath = "clone";
export const aiVariantsPath = "variants";
export const AIAgentPaths = {
    templates: "agent-templates",
    custom: customAgentPath,
    customEdit: `${customAgentPath}/${aiEditPath}`,
    customView: `${customAgentPath}/${aiViewPath}`,
    customClone: `${customAgentPath}/${aiClonePath}`,
    knowledgeBase: knowledgeBasePath,
    kbEdit: `${knowledgeBasePath}/${aiEditPath}/:id`,
    agentNew: `${customAgentPath}/${aiEditPath}/new`,
    agentEdit: `${customAgentPath}/${aiEditPath}/:id/:version`,
    agentActions: `${customAgentPath}/:action/:id/:version`,
    agentTemplateActions: `${customAgentPath}/:action/:agentTemplateId`,
    agentVariants: `${customAgentPath}/:agentId/${aiVariantsPath}`,
} as const;
